module.exports = __webpack_public_path__ + "static/social-0466dd2c8b5f6fe5eaeb1f5826f738b7.png";